import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { countryMobileCodes } from "../../../scripts/countryMobileCodes";
import {
  getTransferDetailsById,
  ownerChangeToNewOwner,
  saveOwnerTransferStatusUpdate,
} from "../../../api/apimethods";
import { IOwnerTransferInfo } from "../../../typings/models/OwnerTransferInfo";
import PetsDashboard from "../../DashBoard/Microchip/Pets/PetsDashboard";
import { AppContext, defaultAppContextData } from "../../../services/appData";
import { useConfig } from "../../../context/ConfigProvider";
import { useAuthService, useContextService } from "../../../services";
import { IcountryOptions } from "../../../typings/models/CountryOption";
import { IPetColorModel } from "../../../typings/models/PetColorModel";
import { IAnimalTypesModel } from "../../../typings/models/AnimalTypesModel";
import { IPetBreedModel } from "../../../typings/models/PetBreedModel";
import fetchColoursOption from "../../../scripts/coloursOption";
import fetchAnimalTypes from "../../../scripts/animalTypes";
import fetchPetBreeds from "../../../scripts/petBreedOptions";
import fetchCountryOptions from "../../../scripts/countryOptions";
import { IOwnerStatus } from "../../../typings/models/OwnerStatus";
import Loader from "../../../components/molecules/Loader";
interface PetsTransferOwnerEditFormProps {
  onSuccessfulSubmit: () => void;
}

const PetsTransferOwnerEditForm: React.FC<PetsTransferOwnerEditFormProps> = ({
  onSuccessfulSubmit,
}) => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );

  const getUserInfo = localStorage.getItem("app-data");

  const user = contextData.user;

  //requester
  let navigate = useNavigate();
  const location = useLocation();
  const petsRegistrationId = location.state?.petsRegistrationId;
  const petsTransferApplicationId = location.state?.petsTransferApplicationId;
  const [ownerType, setOwnerType] = useState<number>(0);
  const [OwnerTypeSelected, setOwnerTypeSelected] = useState(false);
  const [transferNo, setTransferNo] = useState("");
  const [dateofTransfer, setDateofTransfer] = useState("");
  const [requesterId, setRequesterId] = useState("");
  const [requesterIdType, setRequesterIdType] = useState("");
  const [requesterName, setRequesterName] = useState("");
  const [requesterAddress, setRequesterAddress] = useState("");
  const [requesterEmail, setRequesterEmail] = useState("");
  const [requesterMobileNo, setRequesterMobileNo] = useState("");
  const [requesterMobilecode, setRequesterMobileCode] = useState("+65");
  const [requestorType, setRequestorType] = useState("");

  // owner
  const [ownerId, setOwnerId] = useState("");
  const [ownerIdType, setOwnerIdType] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [opostalCode, setoPostalCode] = useState("");
  const [oblockNumber, setoBlockNumber] = useState("");
  const [ostreetName, setoStreetName] = useState("");
  const [ounitNumber, setoUnitNumber] = useState("");
  const [ofloorNumber, setoFloorNumber] = useState("");
  const [obuildingName, setoBuildingName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [mobilecode, setMobileCode] = useState("+65");
  const [email, setEmail] = useState("");

  //new owner
  const [newownerId, setnewOwnerId] = useState("");
  const [newownerIdType, setnewOwnerIdType] = useState("");
  const [newownerName, setnewOwnerName] = useState("");
  const [newopostalCode, setnewoPostalCode] = useState("");
  const [newoblockNumber, setnewoBlockNumber] = useState("");
  const [newostreetName, setnewoStreetName] = useState("");
  const [newounitNumber, setnewoUnitNumber] = useState("");
  const [newofloorNumber, setnewoFloorNumber] = useState("");
  const [newobuildingName, setnewoBuildingName] = useState("");
  const [newmobileNo, setnewMobileNo] = useState("");
  const [newmobilecode, setnewMobileCode] = useState("+65");
  const [newemail, setnewEmail] = useState("");
  const [transferCode, setTransferCode] = useState("");
  const [transferCodeError, setTransferCodeError] = useState(false);
  // const [validatetransferCodeError, setValidateTransferCodeError] =
  //   useState(false);

  //Pet
  const [selectType, setSelectType] = useState<number>(0);
  const [postalCode, setPostalCode] = useState("");
  const [blockNumber, setBlockNumber] = useState("");
  const [streetName, setStreetName] = useState("");
  const [unitNumber, setUnitNumber] = useState("");
  const [floorNumber, setFloorNumber] = useState("");
  const [buildingName, setBuildingName] = useState("");
  const [animalType, setAnimalType] = useState("");
  const [animalTypeLabel, setAnimalTypeLabel] = useState("");
  const [breed, setBreed] = useState("");
  const [origin, setOrigin] = useState("");
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [countries, setCountries] = useState<IcountryOptions[]>([]);
  const [originCountries, setOriginCountries] = useState<IcountryOptions[]>([]);
  const [colourOptions, setColourOptions] = useState<IPetColorModel[]>([]);
  const [animalTypes, setAnimalTypes] = useState<IAnimalTypesModel[]>([]);
  const [breedOptionsByAnimalType, setBreedOptionsByAnimalType] = useState<
    Record<string, IPetBreedModel[]>
  >({});
  const [microchipNo, setMicrochipNo] = useState("");
  const [microchipDate, setMicrochipDate] = useState("");
  const [nameofPet, setNameofPet] = useState("");
  const [dateofBirthPet, setDateofBirthPet] = useState("");
  const [sex, setSex] = useState("");
  const [colour, setColour] = useState("");
  const [sterilised, setSterilised] = useState("");
  const [isCommunityCat, setCommunityCat] = useState<any>(null);
  const [remarks, setRemarks] = useState("");
  const [applicationStatus, setApplicationStatus] = useState("");
  const [petsRegistration, setpetsRegistrationId] =
    useState(petsRegistrationId);
  const [petsTransferId, setpetsTransferId] = useState(
    petsTransferApplicationId
  );
  const [status, setStatus] = useState("");
  const [applicationType, setApplicationType] = useState("");

  const [postalCodeApi, setPostalCodeApi] = useState("");
  const [blockNumberApi, setBlockNumberApi] = useState("");
  const [streetNameApi, setStreetNameApi] = useState("");
  const [unitNumberApi, setUnitNumberApi] = useState("");
  const [floorNumberApi, setFloorNumberApi] = useState("");
  const [buildingNameApi, setBuildingNameApi] = useState("");

  //valaidations

  const [floorNoShowError, setfloorNoShowError] = useState(true);
  const [unitNoShowError, setunitNoShowError] = useState(true);
  const [blockNoShowError, setblockNoShowError] = useState(true);
  const [postalCodeShowError, setpostalCodeShowError] = useState(true);
  const [ofloorNoShowError, setofloorNoShowError] = useState(true);
  const [ounitNoShowError, setounitNoShowError] = useState(true);
  const [oblockNoShowError, setoblockNoShowError] = useState(true);
  const [opostalCodeShowError, setopostalCodeShowError] = useState(true);
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [validEmail, setValidEmail] = useState(true);
  const [validRequesterEmail, setValidRequesterEmail] = useState(true);
  const [newofloorNoShowError, setnewofloorNoShowError] = useState(true);
  const [newounitNoShowError, setnewounitNoShowError] = useState(true);
  const [newoblockNoShowError, setnewoblockNoShowError] = useState(true);
  const [newopostalCodeShowError, setnewopostalCodeShowError] = useState(true);
  const [newvalidMobileNo, setnewValidMobileNo] = useState(true);
  const [newvalidEmail, setnewValidEmail] = useState(true);
  const [isMicrochipValid, setIsMicrochipValid] = useState(true);
  const [addressReadOnly, setAddressReadOnly] = useState(true);
  const [displayAccept, setDisplayAccept] = useState(false);
  const [displayOwner, setDisplayOwner] = useState(false);
  const [displayCancel, setDisplayCancel] = useState(false);
  const [displayOrigOwnerInfo, setDisplayOrigOwnerInfo] = useState(true);

  const [errorMessage, setErrorMessage] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);

  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const errorRef = useRef<HTMLButtonElement>(null);
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  //Date validation
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate()); // Set it to today
  const maxdate = currentDate.toISOString().split("T")[0];

  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmiting, setSubmiting] = useState(false);
  const [isValidDate, setisValidDate] = useState(true);

  const [isValidRegistrationId, setisValidRegistrationId] = useState(false);
  const transferType = "PetsPendingRegistration";
  const [isMinValidDate, setisMinValidDate] = useState(true);
  const [isValidDateofBirth, setisValidDateofBirth] = useState(true);
  const [isMinValidDateofBirth, setisMinValidDateofBirth] = useState(true);

  const initialRender = useRef(true);
  const inputCountryRef = useRef(true);
  const inputColoursRef = useRef(true);
  const inputAnimalTypeRef = useRef(true);
  const inputPetBreedRef = useRef(true);
  const minDate = "1990-01-01";
  let responseTransferCode: string;

  const handleOriginChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    // Validate the Microchip No. based on the selected "Origin"
    if (microchipNo !== "") {
      if (value === "1") {
        // Local origin validation: 15 digits, numeric
        const isValid = /^[a-zA-Z0-9]{15,20}$/.test(microchipNo);
        setIsMicrochipValid(isValid);
        // setIsMicrochipValidOversease(true);
      } else if (value === "2") {
        // Overseas origin validation: No specific validation
        const isValid = /^[a-zA-Z0-9]{15,20}$/.test(microchipNo);
        setIsMicrochipValid(isValid);
        // setIsMicrochipValidOversease(true);
      }
    }
    if (value === "1") {
      const singaporeFilteredCountries = countries.filter(
        (country) => country.label === "Singapore"
      );
      setOriginCountries(singaporeFilteredCountries);
    } else if (value === "2") {
      // Overseas origin validation: No specific validation
      setOriginCountries(countries);
    }

    // Update the Microchip No. state
    setOrigin(value);
  };

  const handleMicrochipDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);
    const maxdateObj = new Date(maxdate);
    const mindateObj = new Date(minDate);
    if (maxdateObj >= selectedDateObj) {
      setMicrochipDate(selectedDate);
      setisValidDate(true);
    } else {
      event.preventDefault();
      setisValidDate(false);
      setMicrochipDate("");
    }
    if (mindateObj <= selectedDateObj) {
      setMicrochipDate(selectedDate);
      setisMinValidDate(true);
    } else {
      event.preventDefault();
      setisValidDate(true);
      setisMinValidDate(false);
      setMicrochipDate("");
    }
  };

  const handlePetbirthDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);
    const maxdateObj = new Date(maxdate);
    const mindateObj = new Date(minDate);
    if (maxdateObj >= selectedDateObj) {
      setDateofBirthPet(selectedDate);
      setisValidDateofBirth(true);
    } else {
      event.preventDefault();
      setisValidDateofBirth(false);
      setDateofBirthPet("");
    }
    if (mindateObj <= selectedDateObj) {
      setDateofBirthPet(selectedDate);
      setisMinValidDateofBirth(true);
    } else {
      event.preventDefault();
      setisValidDateofBirth(true);
      setisMinValidDateofBirth(false);
      setDateofBirthPet("");
    }
  };

  useEffect(() => {
    if (inputCountryRef.current) {
      inputCountryRef.current = false;
      const fetchData = async () => {
        const countries = await fetchCountryOptions();
        setOriginCountries(countries);
        setCountries(countries);
        setIsLoading(false);
      };

      fetchData();
    }
  }, []);

  useEffect(() => {
    if (inputColoursRef.current) {
      inputColoursRef.current = false;
      const fetchColourData = async () => {
        const petsColours = await fetchColoursOption();
        setColourOptions(petsColours);
      };

      fetchColourData();
    }
  }, []);

  useEffect(() => {
    if (inputAnimalTypeRef.current) {
      inputAnimalTypeRef.current = false;
      const fetchAnimalType = async () => {
        const animalTypes = await fetchAnimalTypes();
        setAnimalTypes(animalTypes);
      };

      fetchAnimalType();
    }
  }, []);

  useEffect(() => {
    if (inputPetBreedRef.current) {
      inputPetBreedRef.current = false;
      const fetchPetBreed = async () => {
        const petBreeds = await fetchPetBreeds();
        const breedOptions = petBreeds.reduce((options, petBreed) => {
          const animalTypeId = petBreed.animalType;
          options[animalTypeId] = options[animalTypeId] || [];
          options[animalTypeId].push(petBreed);
          return options;
        }, {} as Record<string, IPetBreedModel[]>);
        setBreedOptionsByAnimalType(breedOptions);
      };

      fetchPetBreed();
    }
  }, []);

  const handleCountryofOriginChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setCountryOfOrigin(event.target.value);
  };

  const handleAnimalTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedAnimalType = event.target.value;
    const selectedAnimalTypelabel =
      animalTypes.find((type) => type.id === selectedAnimalType)?.name ?? "";
    setAnimalType(selectedAnimalType);
    setAnimalTypeLabel(selectedAnimalTypelabel);
    setBreed(""); // Reset the breed when animal type changes
  };

  useEffect(() => {
    // Skip the initial render check

    // if (initialRender.current) {
    //   initialRender.current = false;
    //   return;
    // }

    if (petsRegistrationId === undefined) {
      // Handle the case where petsRegistrationId is not available
      setisValidRegistrationId(true);
      setIsLoading(false);
    } else {
      try {
        const fetchData = async () => {
          var response = null;
          setDisplayOrigOwnerInfo(true);
          setDisplayOwner(true);
          setpetsRegistrationId(petsRegistrationId);
          if (
            petsTransferApplicationId != null &&
            petsTransferApplicationId != undefined &&
            user.idNo != undefined &&
            user.email != undefined
          ) {
            response = await getTransferDetailsById(
              petsTransferApplicationId,
              user.idNo,
              user.email
            );

            if (response.data) {
              if (response.data.requesterType === "1") setOwnerType(1);
              else {
                setOwnerType(2);

                setDisplayOwner(response.data.populateOwnerInfo);
              }

              setDisplayOrigOwnerInfo(response.data.populateNewOwnerInfo);
              setRequestorType(response.data.requesterType);
              if (response.data.dateofTransfer != undefined)
                setDateofTransfer(response.data.dateofTransfer.split("T")[0]);
              setpetsRegistrationId(petsRegistrationId);
              setpetsTransferId(petsTransferApplicationId);
              setOwnerId(response.data.ownerIDNumber);
              setOwnerIdType(response.data.ownerID);
              setOwnerName(response.data.ownerName);
              setoPostalCode(response.data.ownerPostalCode);
              setoBlockNumber(response.data.ownerBlockHouseNumber);
              setoStreetName(response.data.ownerStreetName);
              setoUnitNumber(response.data.ownerUnitNumber);
              setoFloorNumber(response.data.ownerFloorNumber);
              setoBuildingName(response.data.ownerBuildingName);
              setnewOwnerId(response.data.newOwnerIDNumber);
              setnewOwnerIdType(response.data.newOwnerID);
              setnewOwnerName(response.data.newOwnerName);
              setnewoPostalCode(response.data.newOwnerPostalCode);
              setnewoBlockNumber(response.data.newOwnerBlockHouseNumber);
              setnewoStreetName(response.data.newOwnerStreetName);
              setnewoUnitNumber(response.data.newOwnerUnitNumber);
              setnewoFloorNumber(response.data.newOwnerFloorNumber);
              setnewoBuildingName(response.data.newOwnerBuildingName);

              const phnumber = response.data.ownerContactNo;

              if (phnumber && phnumber.length !== undefined) {
                const phcode = phnumber.substring(0, 3);
                const number = phnumber.substring(3);
                setMobileNo(number);
                setMobileCode(phcode);
              } else {
                setMobileNo("");
                setMobileCode("+65");
              }

              setEmail(response.data.ownerEmail);
              setAnimalType(response.data.animalTypeID);
              setRemarks(response.data.remarks);
              setCommunityCat(response.data.isCommunityCat);
              setBreed(response.data.breedID);
              setRemarks(response.data.remarks);
              setOrigin(response.data.petsOrigin);
              setNameofPet(response.data.petsName);
              setSex(response.data.petsSex);
              setRemarks(response.data.remarks);
              setColour(response.data.petsColourID);
              setSterilised(response.data.petsSterilised);
              setSelectType(response.data.petInformationType);
              setMicrochipDate(
                response.data.microchipDate.toString().split("T")[0]
              );

              const petsCountryOfOriginID = response.data.petsCountryOfOriginID;
              setCountryOfOrigin(petsCountryOfOriginID || "");
              setDateofBirthPet(
                response.data.dateOfBirth.toString().split("T")[0]
              );

              const newownerphnumber = response.data.newOwnerContactNo;
              if (newownerphnumber && newownerphnumber.length !== undefined) {
                const phcode = newownerphnumber.substring(0, 3); // Extract the first 3 characters
                const number = newownerphnumber.substring(3); // Extract the remaining characters
                setnewMobileNo(number);
                setnewMobileCode(phcode);
              } else {
                setnewMobileNo(newownerphnumber || "");
                setnewMobileCode("+65");
              }

              setnewEmail(response.data.newOwnerEmail);

              setPostalCode(response.data.petsPostalCode);
              setBlockNumber(response.data.petsBlockHouseNumber);
              setStreetName(response.data.petsStreetName);
              setUnitNumber(response.data.petsUnitNumber);
              setFloorNumber(response.data.petsFloorNumber);
              setBuildingName(response.data.petsBuildingName);
              setMicrochipNo(response.data.petsMicrochipNo);
              setRemarks(response.data.remarks);

              setStatus(response.data.status);
              setApplicationType(response.data.applicationType);

              if (response.data.transferCode != null) {
                responseTransferCode = response.data.transferCode;
              }

              if (response.data.remarks != null) {
                setRemarks(response.data.remarks);
              }

              if (
                response.data.petsPostalCode ===
                  response.data.ownerPostalCode &&
                response.data.petsBlockHouseNumber ===
                  response.data.ownerBlockHouseNumber &&
                response.data.petsFloorNumber ===
                  response.data.ownerFloorNumber &&
                response.data.petsStreetName ===
                  response.data.ownerStreetName &&
                response.data.petsUnitNumber ===
                  response.data.ownerUnitNumber &&
                response.data.petsBuildingName ===
                  response.data.ownerBuildingName
              ) {
                setSelectType(1);
                setAddressReadOnly(true);
              } else {
                setSelectType(2);
                setAddressReadOnly(false);
              }
              setDisplayAccept(response.data.displayAcceptDecline === true);
              setDisplayCancel(response.data.displayCancel === true);

              if (
                response.data.populateNewOwnerInfo &&
                (response.data.status == null ||
                  response.data.status == undefined) &&
                newownerId === "" &&
                user !== undefined
              ) {
                if (user.idType != undefined) setnewOwnerIdType("2");
                if (user.idNo != undefined) setnewOwnerId(user.idNo);
                if (user.registeredAddresses != undefined) {
                  setnewoPostalCode(user?.registeredAddresses?.[0]?.postalCode);
                  setnewoBlockNumber(
                    user?.registeredAddresses?.[0]?.blockHouseNo
                  );
                  setnewoStreetName(user?.registeredAddresses?.[0]?.streetName);
                  setnewoFloorNumber(
                    user?.registeredAddresses?.[0]?.floorLevel
                  );
                  setnewoUnitNumber(user?.registeredAddresses?.[0]?.unit);
                  setnewoBuildingName(
                    user?.registeredAddresses?.[0]?.buildingName
                  );
                }
              }
              // if (
              //   user.idNo === response.data.newOwnerIDNumber &&
              //   response.data.requesterType === "1"
              // )
              //   setDisplayAccept(true);
              // if (
              //   user.idNo === response.data.ownerIDNumber &&
              //   response.data.requesterType === "2"
              // )
              //   setDisplayAccept(true);
            }
          }
          //setCountries(countries);
          setIsLoading(false);
        };
        fetchData();
      } catch (error) {
        setIsLoading(false);
      }
    }
  }, [petsRegistrationId]);

  async function handleOwnerChangeToNewOwner(OwnerTransferInfo: any) {
    var response = null;
    try {
      response = await ownerChangeToNewOwner(OwnerTransferInfo);
      if (response.data.data) {
        var status = "";
        let msg = "Your request for transfer application has been ";
        if (OwnerTransferInfo.Status === "Accept") {
          msg += "accepted.";
          status = "4";
        } else if (OwnerTransferInfo.Status === "Decline") {
          msg += "declined.";
          status = "5";
        } else if (OwnerTransferInfo.Status === "Cancel") {
          msg += "cancelled.";
          status = "6";
        }
        alert(msg);
        // onUpdateItem(data, status);
        onSuccessfulSubmit();
      } else {
        // API call failed
        const errorMessage = response.data.message;
        setErrorMessage(errorMessage);
        if (errorRef.current) {
          errorRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (error) {
      const errorMessage = "An error occurred. Please try again.";
      setErrorMessage(errorMessage);
      if (errorRef.current) {
        errorRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
    setSubmiting(false);
  }

  const handleAccept = async () => {
    const reCaptchaResponse = recaptchaRef.current?.getValue();
    let aOwnerType = isOwnerTypeSelected();
    setOwnerTypeSelected(aOwnerType);
    if (!reCaptchaResponse) {
      // reCAPTCHA validation failed
      setIsCaptchaValid(false);
      return;
    }
    if (transferCode === undefined || transferCode === "") {
      setTransferCodeError(true);
      return;
    }
    // if (transferCode != responseTransferCode) {
    //   setValidateTransferCodeError(true);
    //   return;
    // }
    setSubmiting(true);
    // Set the status to "Accepted" or equivalent in your application
    const OwnerTransferInfo: IOwnerStatus = {
      PetsRegistrationId: petsRegistration,
      PetsTransferApplicationId: petsTransferId,
      TransferCode: transferCode,
      Status: "Accept",
      LoginUserId: user?.idNo || "",
      LoginUserEmail: user?.email || "",
      LoginType:
        user.role === "SingPass" ? "1" : user.role === "CorpPass" ? "2" : "3",

      NewOwnerInformation: {
        OwnerID: newownerIdType,
        OwnerIDNumber: newownerId,
        OwnerName: newownerName,
        BlockHouseNumber: newoblockNumber,
        StreetName: newostreetName,
        FloorNumber: newofloorNumber,
        UnitNumber: newounitNumber,
        BuildingName: newobuildingName,
        PostalCode: newopostalCode,
        OwnerContactNo: newmobilecode + newmobileNo,
        OwnerAlternateContactNo: "",
        OwnerEmail: newemail,
      },
    };
    handleOwnerChangeToNewOwner(OwnerTransferInfo);
  };

  const handleDecline = async () => {
    setSubmiting(true);
    // const reCaptchaResponse = recaptchaRef.current?.getValue();
    let aOwnerType = isOwnerTypeSelected();
    setOwnerTypeSelected(aOwnerType);
    // if (!reCaptchaResponse) {
    //   // reCAPTCHA validation failed
    //   setIsCaptchaValid(false);
    //   return;
    // }

    const OwnerTransferInfo: IOwnerStatus = {
      PetsRegistrationId: petsRegistrationId,
      PetsTransferApplicationId: petsTransferId,
      TransferCode: "",
      Status: "Decline",
      LoginUserId: user?.idNo || "",
      LoginUserEmail: user?.email || "",
      LoginType:
        user.role === "SingPass" ? "1" : user.role === "CorpPass" ? "2" : "3",

      NewOwnerInformation: {
        OwnerID: newownerIdType,
        OwnerIDNumber: newownerId,
        OwnerName: newownerName,
        BlockHouseNumber: newoblockNumber,
        StreetName: newostreetName,
        FloorNumber: newofloorNumber,
        UnitNumber: newounitNumber,
        BuildingName: newobuildingName,
        PostalCode: newopostalCode,
        OwnerContactNo: newmobilecode + newmobileNo,
        OwnerAlternateContactNo: "",
        OwnerEmail: newemail,
      },
    };
    if (window.confirm("Are you sure you want to decline the transfer?")) {
      handleOwnerChangeToNewOwner(OwnerTransferInfo);
    } else setSubmiting(false);
  };

  const handleCancel = async () => {
    setSubmiting(true);

    const reCaptchaResponse = recaptchaRef.current?.getValue();
    let aOwnerType = isOwnerTypeSelected();
    setOwnerTypeSelected(aOwnerType);
    // if (!reCaptchaResponse) {
    //   // reCAPTCHA validation failed
    //   setIsCaptchaValid(false);
    //   return;
    // }
    // Set the status to "Declined" or equivalent in your application
    const OwnerTransferInfo: IOwnerStatus = {
      PetsRegistrationId: petsRegistrationId,
      PetsTransferApplicationId: petsTransferId,
      TransferCode: "",
      Status: "Cancel",
      LoginUserId: user?.idNo || "",
      LoginUserEmail: user?.email || "",
      LoginType:
        user.role === "SingPass" ? "1" : user.role === "CorpPass" ? "2" : "3",

      NewOwnerInformation: {
        OwnerID: newownerIdType,
        OwnerIDNumber: newownerId,
        OwnerName: newownerName,
        BlockHouseNumber: newoblockNumber,
        StreetName: newostreetName,
        FloorNumber: newofloorNumber,
        UnitNumber: newounitNumber,
        BuildingName: newobuildingName,
        PostalCode: newopostalCode,
        OwnerContactNo: newmobilecode + newmobileNo,
        OwnerAlternateContactNo: "",
        OwnerEmail: newemail,
      },
    };
    if (window.confirm("Are you sure you want to cancel the transfer?")) {
      handleOwnerChangeToNewOwner(OwnerTransferInfo);
    } else setSubmiting(false);
  };

  // Handle microchip  vaidation
  const handleMicrochipChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    const isValid = /^[a-zA-Z0-9]{3,100}$/.test(value);
    setIsMicrochipValid(isValid);
    // Update the Microchip No. state
    setMicrochipNo(value);
  };

  // Transfer date vaidation
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    // const selectedDateObj = new Date(selectedDate);
    // const maxdateObj = new Date(maxdate);
    // if (maxdateObj >= selectedDateObj) {
    //   setMicrochipDate(selectedDate);
    //   setisValidDate(true);
    // } else {
    //   event.preventDefault();
    //   setisValidDate(false);
    //   setMicrochipDate("");
    // }
    setDateofTransfer(selectedDate);
    setisValidDate(true);
  };

  const blockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (new RegExp(pattern).test(value)) {
      setBlockNumber(value);
      setblockNoShowError(true);
    } else {
      if (value === "") {
        setBlockNumber(value);
        setblockNoShowError(true);
      } else {
        setblockNoShowError(false);
      }
    }
  };

  const postalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setPostalCode(value);
      setpostalCodeShowError(true);
    } else {
      if (value === "") {
        setPostalCode(value);
        setpostalCodeShowError(true);
      } else {
        setpostalCodeShowError(false);
      }
    }
  };

  const unitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

    if (new RegExp(pattern).test(value)) {
      setUnitNumber(value);
      setunitNoShowError(true);
    } else {
      if (value === "") {
        setUnitNumber(value);
        setunitNoShowError(true);
      } else {
        setunitNoShowError(false);
      }
    }
  };

  const floorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setFloorNumber(value);
      setfloorNoShowError(true);
    } else {
      if (value === "") {
        setFloorNumber(value);
        setfloorNoShowError(true);
      } else {
        setfloorNoShowError(false);
      }
    }
  };

  const oblockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setoBlockNumber(value);
      setoblockNoShowError(true);
    } else {
      if (value === "") {
        setoBlockNumber(value);
        setoblockNoShowError(true);
      } else {
        setoblockNoShowError(false);
      }
    }
  };

  const opostalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setoPostalCode(value);
      setopostalCodeShowError(true);
    } else {
      if (value === "") {
        setoPostalCode(value);
        setopostalCodeShowError(true);
      } else {
        setopostalCodeShowError(false);
      }
    }
  };

  const ounitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

    if (new RegExp(pattern).test(value)) {
      setoUnitNumber(value);
      setounitNoShowError(true);
    } else {
      if (value === "") {
        setoUnitNumber(value);
        setounitNoShowError(true);
      } else {
        setounitNoShowError(false);
      }
    }
  };

  const ofloorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setoFloorNumber(value);
      setofloorNoShowError(true);
    } else {
      if (value === "") {
        setoFloorNumber(value);
        setofloorNoShowError(true);
      } else {
        setofloorNoShowError(false);
      }
    }
  };

  const oblockNonewHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setnewoBlockNumber(value);
      setnewoblockNoShowError(true);
    } else {
      if (value === "") {
        setnewoBlockNumber(value);
        setnewoblockNoShowError(true);
      } else {
        setnewoblockNoShowError(false);
      }
    }
  };

  const opostalCodenewHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setnewoPostalCode(value);
      setnewopostalCodeShowError(true);
    } else {
      if (value === "") {
        setnewoPostalCode(value);
        setnewopostalCodeShowError(true);
      } else {
        setnewopostalCodeShowError(false);
      }
    }
  };

  const ounitNonewHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

    if (new RegExp(pattern).test(value)) {
      setnewoUnitNumber(value);
      setnewounitNoShowError(true);
    } else {
      if (value === "") {
        setnewoUnitNumber(value);
        setnewounitNoShowError(true);
      } else {
        setnewounitNoShowError(false);
      }
    }
  };

  const ofloorNonewHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = "^[a-zA-Z0-9s]+$";

    if (new RegExp(pattern).test(value)) {
      setnewoFloorNumber(value);
      setnewofloorNoShowError(true);
    } else {
      if (value === "") {
        setnewoFloorNumber(value);
        setnewofloorNoShowError(true);
      } else {
        setnewofloorNoShowError(false);
      }
    }
  };

  const handleRequesterEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setRequesterEmail(value);
    if (pattern.test(value)) {
      setValidRequesterEmail(true);
    } else {
      if (value === "") {
        setValidRequesterEmail(true);
      } else {
        setValidRequesterEmail(false);
      }
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  const handlenewEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setnewEmail(value);
    if (pattern.test(value)) {
      setnewValidEmail(true);
    } else {
      if (value === "") {
        setnewValidEmail(true);
      } else {
        setnewValidEmail(false);
      }
    }
  };

  const mobileRequesterNoHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setRequesterMobileNo(value);
      if (value.length >= 8) {
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    } else {
      if (value === "") {
        setRequesterMobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }
    // Check if the selected mobile code is +65 (Singapore)
    if (requesterMobilecode === "+65") {
      // Validate for 8 digits
      const isValid = /^[0-9]{8}$/.test(value);
      setValidMobileNo(isValid);
    } else {
      // For other country codes, no specific validation
      setValidMobileNo(true);
    }
  };

  const mobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setMobileNo(value);
      if (value.length >= 8) {
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    } else {
      if (value === "") {
        setMobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }
    // Check if the selected mobile code is +65 (Singapore)
    if (mobilecode === "+65") {
      // Validate for 8 digits
      const isValid = /^[0-9]{8}$/.test(value);
      setValidMobileNo(isValid);
    } else {
      // For other country codes, no specific validation
      setValidMobileNo(true);
    }
  };

  const mobileNonewHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setnewMobileNo(value);
      if (value.length >= 8) {
        setnewValidMobileNo(true);
      } else {
        setnewValidMobileNo(false);
      }
    } else {
      if (value === "") {
        setnewMobileNo(value);
        setnewValidMobileNo(true);
      } else {
        setnewValidMobileNo(false);
      }
    }
    // Check if the selected mobile code is +65 (Singapore)
    if (newmobilecode === "+65") {
      // Validate for 8 digits
      const isValid = /^[0-9]{8}$/.test(value);
      setnewValidMobileNo(isValid);
    } else {
      // For other country codes, no specific validation
      setnewValidMobileNo(true);
    }
  };

  const isOwnerTypeSelected = () => {
    return ownerType !== null && ownerType !== 0;
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const handleRequesterIdTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedOwnerIdType = event.target.value;
    setRequesterIdType(selectedOwnerIdType);
  };

  const handleOwnerIdTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedOwnerIdType = event.target.value;
    setOwnerIdType(selectedOwnerIdType);
  };

  const handlenewOwnerIdTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedOwnerIdType = event.target.value;
    setnewOwnerIdType(selectedOwnerIdType);
  };

  const isSelectPetTypeSelected = () => {
    return selectType !== null && selectType !== 0;
  };

  //   useEffect(() => {
  //     if (
  //       ownerId &&
  //       opostalCode &&
  //       oblockNumber &&
  //       ostreetName &&
  //       ounitNumber &&
  //       ofloorNumber &&
  //       obuildingName
  //     ) {
  //       setSelectType(1); // Assuming '1' means "Same as owner"
  //       setPostalCode(opostalCode);
  //       setBlockNumber(oblockNumber);
  //       setStreetName(ostreetName);
  //       setUnitNumber(ounitNumber);
  //       setFloorNumber(ofloorNumber);
  //       setBuildingName(obuildingName);
  //     }
  //   }, [
  //     ownerId,
  //     opostalCode,
  //     oblockNumber,
  //     ostreetName,
  //     ounitNumber,
  //     ofloorNumber,
  //     obuildingName,
  //   ]); // Dependency array

  if (isLoading) {
    return <Loader />;
  }

  const handleSubmit = async (
    event:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    try {
      setSubmitted(true);
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      let aOwnerType = isOwnerTypeSelected();
      setOwnerTypeSelected(aOwnerType);
      if (!reCaptchaResponse) {
        // reCAPTCHA validation failed
        setIsCaptchaValid(false);
        return;
      }
      if (isAllValidation()) {
        var response = null;
        if (
          OwnerTransferInfo.NewOwnerInformations.OwnerIDNumber == "2" &&
          OwnerTransferInfo.NewOwnerInformations.OwnerID == "VX123456"
        ) {
          const errorMessage =
            "You are/This Owner ID is not allowed to register for a pet microchip.";
          setErrorMessage(errorMessage); // Set the error message in state
          return;
        }
        setSubmiting(true);
        response = await saveOwnerTransferStatusUpdate(OwnerTransferInfo);
        if (response.data) {
          setSubmiting(false);
          const errorMessage =
            "You have request to transfer a" +
            // animalTypeLabel +
            " with Microchip No. " +
            microchipNo +
            " to the new owner. You will be notified when your transfer request is accepted or declined.";
          alert(errorMessage);
          //<PetsDashboard RegistrationType={""} transferType={transferType} />;
          // let path = `/app-pet-dashboard`;
          // navigate(path, { state: { transferType } });
          onSuccessfulSubmit();
        } else {
          // API call failed
          setSubmiting(false);
          <PetsDashboard RegistrationType={""} transferType={transferType} />;
          // let path = `/app-pet-dashboard`;
          // navigate(path, { state: { transferType } });
          //const errorMessage = "Wrong microchip number against the owner";
          //setErrorMessage(errorMessage); // Set the error message in state
        }
      }
    } catch (error) {
      // Handle any errors
      setSubmiting(false);
      console.error(error);
    }
  };

  (function () {
    

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();
  // Include the applicantName value in your API request
  // Prepare the request payload
  const OwnerTransferInfo: IOwnerTransferInfo = {
    PetsRegistrationId: petsRegistration,
    RequesterType: ownerType,
    TransferNo: transferNo,
    DateofTransfer: dateofTransfer,
    PetInformationType: selectType,
    Remarks: remarks,
    ApplicationStatus: applicationStatus,
    AnimalType: "",
    Breed: "",
    LoginUserId: user?.idNo || "",
    LoginUserEmail: user?.email || "",
    LoginType:
      user.role === "SingPass" ? "1" : user.role === "CorpPass" ? "2" : "3",

    isCommunityCat: isCommunityCat,
    RequestorInformations: {
      RequestorID: requesterId,
      RequestorIDNumber: requesterIdType,
      RequestorName: requesterName,
      RequestorAddress: requesterAddress,
      RequestorContactNo: requesterMobilecode + requesterMobileNo,
      RequestorEmail: requesterEmail,
    },
    PetsInformations: {
      Origin: "",
      CountryOfOrigin: "",
      MicrochipNo: microchipNo,
      MicrochipDate: "",
      PetsName: "",
      PetsDateOfBirth: "",
      PetsSex: "",
      PetsColour: "",
      Sterilised: "",
      isCommunityCat: isCommunityCat,
      BlockHouseNumber: blockNumber,
      StreetName: streetName,
      FloorNumber: floorNumber,
      UnitNumber: unitNumber,
      BuildingName: buildingName,
      PostalCode: postalCode,
      petInformationType: selectType,
    },
    OriginalOwnerInformations: {
      OwnerID: ownerId,
      OwnerIDNumber: ownerIdType,
      OwnerName: ownerName,
      BlockHouseNumber: oblockNumber,
      StreetName: ostreetName,
      FloorNumber: ofloorNumber,
      UnitNumber: ounitNumber,
      BuildingName: obuildingName,
      PostalCode: opostalCode,
      OwnerContactNo: mobilecode + mobileNo,
      OwnerAlternateContactNo: "",
      OwnerEmail: email,
    },
    NewOwnerInformations: {
      OwnerID: newownerId,
      OwnerIDNumber: newownerIdType,
      OwnerName: newownerName,
      BlockHouseNumber: newoblockNumber,
      StreetName: newostreetName,
      FloorNumber: newofloorNumber,
      UnitNumber: newounitNumber,
      BuildingName: newobuildingName,
      PostalCode: newopostalCode,
      OwnerContactNo: newmobilecode + newmobileNo,
      OwnerAlternateContactNo: "",
      OwnerEmail: newemail,
    },
  };

  const isAllValidation = () => {
    return isValidDate && checkboxChecked && validEmail;
  };

  return (
    <>
      <h2 className="pb-2">Registration</h2>
      <div className="inst-cnt mt-4 mb-2">
        <span className="est-time">
          <i className="fas fa-clock"></i> Estimated time to complete: 15 mins
        </span>
      </div>
      <form
        className="row g-3 needs-validation"
        onSubmit={handleSubmit}
        noValidate
      >
        <div
          className="passport-details hidden csp-display-block"
          id="passport"
        >
          <h2 className="pb-0">Transfer Pets Ownership</h2>
          <div className="inst-cnt mt-2">
            {/* components should be there */}
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className={`form-label mb-2 ${
                  !isOwnerTypeSelected() ? "required" : ""
                }`}
              >
                1. Transfer of Pets Ownership Information{" "}
                <span className="star">*</span>{" "}
              </label>
              <div
                className={`form-check ${
                  !isOwnerTypeSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="serviceType"
                  value="Myself"
                  id="flexRadioDefault67"
                  checked={ownerType === 1}
                  onChange={() => setOwnerType(1)}
                  disabled
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault67"
                >
                  I am the original owner
                </label>
              </div>
              {isValidRegistrationId && (
                <div
                  className={`form-check ${
                    !isOwnerTypeSelected() ? "is-invalid" : ""
                  }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="serviceType"
                    value="Organisation"
                    id="flexRadioDefault78"
                    checked={ownerType === 2}
                    onChange={() => setOwnerType(2)}
                    disabled
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault78"
                  >
                    I am the new owner
                  </label>
                </div>
              )}
              {/* {isValidRegistrationId && (
                <div
                  className={`form-check ${
                    !isOwnerTypeSelected() ? "is-invalid" : ""
                  }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="serviceType"
                    value="Organisation"
                    id="flexRadioDefault79"
                    checked={ownerType === 3}
                    onChange={() => setOwnerType(3)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault79"
                  >
                    On Behalf of Owner
                  </label>
                </div>
              )} */}
              {submitted && !isOwnerTypeSelected() && (
                <div className="invalid-feedback">
                  Please select a Owner type.
                </div>
              )}
            </div>

            {/* <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                2. Transfer No
              </label>
              <input
                type="text"
                className="form-control"
                id="TransferNo"
                placeholder=""
                maxLength={25}
                value={transferNo}
                onChange={(event) => setTransferNo(event.target.value)}
              />
            </div> */}
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                2. Date of Transfer <span className="star">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="DateofTransfer"
                value={dateofTransfer}
                onChange={handleDateChange}
                required
                disabled
              />
              {isValidDate && (
                <div className="invalid-feedback">
                  Please provide a Transfer Date.
                </div>
              )}
            </div>

            {ownerType === 3 && (
              <div>
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    3. Requester ID Type <span className="star">*</span>{" "}
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="requesterIdType"
                    value={requesterIdType}
                    onChange={handleRequesterIdTypeChange}
                    required
                    disabled
                  >
                    <option value=""></option>
                    <option value="1">NRIC</option>
                    <option value="2">FIN</option>
                    <option value="4">UEN</option>
                  </select>
                  <div className="invalid-feedback">
                    Please select Requester ID Type.
                  </div>
                </div>
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    4. Requester ID <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="requesterId"
                    placeholder=""
                    maxLength={25}
                    value={requesterId}
                    onChange={(event) => setRequesterId(event.target.value)}
                    required
                    disabled
                  />
                  <div className="invalid-feedback">
                    Please provide a Requester ID.
                  </div>
                </div>
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    5. Requester Name <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="requesterName"
                    placeholder=""
                    maxLength={255}
                    value={requesterName}
                    onChange={(event) => setRequesterName(event.target.value)}
                    required
                    disabled
                  />
                  <div className="invalid-feedback">
                    Please provide a Requester Name.
                  </div>
                </div>
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    6. Requester Address <span className="star">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="requesterAddress"
                    placeholder=""
                    maxLength={255}
                    value={requesterAddress}
                    onChange={(event) =>
                      setRequesterAddress(event.target.value)
                    }
                    required
                    disabled
                  />
                  <div className="invalid-feedback">
                    Please provide a Requester Address.
                  </div>
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    7. Requester Email<span className="star">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="requesterEmail"
                    placeholder=""
                    maxLength={255}
                    value={requesterEmail}
                    onChange={handleRequesterEmailChange}
                    required
                    disabled
                  />
                  <div className="invalid-feedback">
                    Please provide a Email.
                  </div>
                  {!validRequesterEmail && (
                    <p className="error-message">
                      Invalid email format. eg. abc@de.lk
                    </p>
                  )}
                </div>
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    8. Requester Contact No <span className="star">*</span>
                  </label>

                  <div className="row">
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="requesterMobilecode"
                        value={requesterMobilecode}
                        onChange={(e) => setRequesterMobileCode(e.target.value)}
                        required
                        disabled
                      >
                        {countryMobileCodes.map((code: any) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-10">
                      <input
                        type="text"
                        aria-describedby="emailHelp"
                        className={`form-control ${
                          !validMobileNo ? "is-invalid" : ""
                        }`}
                        id="requesterMobileNo"
                        placeholder=""
                        pattern="[0-9]+"
                        value={requesterMobileNo}
                        onChange={mobileRequesterNoHandler}
                        maxLength={requesterMobilecode === "+65" ? 8 : 66}
                        required
                        disabled
                      />
                      <div className="invalid-feedback">
                        Please provide a contact Number.
                      </div>
                      {!validMobileNo && (
                        <div className="invalid-feedback">
                          Invalid mobile no. eg. +6591234567
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <h2 className="pt-2 pb-0">Pet Information</h2>
          <div className="inst-cnt mt-2">
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                3. Animal Type <span className="star">*</span>{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="animalType"
                value={animalType}
                onChange={handleAnimalTypeChange}
                required
                disabled
              >
                <option value=""></option>
                {animalTypes.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
              <div className="invalid-feedback">
                Please provide an Animal Type.
              </div>
            </div>

            {animalType === "e0df8145-1d5d-ed11-9561-0022485935af" && (
              <div className="mb-2">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  Community Cat <span className="star">*</span>
                </label>
                <div className="d-flex mb-2 position-relative">
                  <div
                    className={`form-check form-check-inline ${
                      !selectType ? "is-invalid" : ""
                    }`}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="isCommunityCat"
                      value={1}
                      id="communityCatYes"
                      checked={isCommunityCat == 1}
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="communityCatYes"
                    >
                      Yes
                    </label>
                  </div>
                  <div
                    className={`form-check form-check-inline ${
                      !selectType ? "is-invalid" : ""
                    }`}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="isCommunityCat"
                      value={0}
                      id="communityCatNo"
                      checked={isCommunityCat == 0}
                      disabled
                    />
                    <label
                      className="form-check-label"
                      htmlFor="communityCatNo"
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                4. Breed <span className="star">*</span>{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="breed"
                value={breed}
                onChange={(e) => setBreed(e.target.value)}
                required
                disabled
              >
                <option value=""></option>
                {breedOptionsByAnimalType[animalType]?.map(
                  (breedOption: IPetBreedModel, index: number) => (
                    <option key={index} value={breedOption.id}>
                      {breedOption.breedName}
                    </option>
                  )
                )}
              </select>
              <div className="invalid-feedback">Please provide a Breed.</div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                5. Origin <span className="star">*</span>{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="origin"
                value={origin}
                onChange={handleOriginChange}
                required
                disabled
              >
                <option value=""></option>
                <option value="1">Local</option>
                <option value="2">Overseas</option>
              </select>
              <div className="invalid-feedback">Please select Origin.</div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                6. Country of Origin{" "}
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="countryOfOrigin"
                value={countryOfOrigin}
                onChange={handleCountryofOriginChange}
                disabled
              >
                {/* <option value=""></option> */}
                {originCountries.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-2 ">
              {ownerType !== 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  7. Microchip No.
                  <span className="star">*</span>
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  23. Microchip No.
                  <span className="star">*</span>
                </label>
              )}
              <input
                type="text"
                className={`form-control ${
                  !isMicrochipValid ? "is-invalid" : ""
                }`}
                id="microchipNo"
                placeholder=""
                maxLength={100}
                value={microchipNo}
                onChange={handleMicrochipChange}
                required
                disabled
              />
              {!isMicrochipValid && (
                <div className="invalid-feedback">
                  Please enter a valid Microchip No. Digits: 0 to 9. And should
                  have 15 digits only.
                </div>
              )}
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                8. Microchip Date <span className="star">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="microchipDate"
                value={microchipDate}
                onChange={handleMicrochipDateChange}
                onBlur={handleMicrochipDateChange}
                max={maxdate}
                required
                min={minDate}
                disabled
              />
              {isValidDate && (
                <div className="invalid-feedback">
                  Please provide a Microchip Date.
                </div>
              )}
              {!isMinValidDate && (
                <p className="error-message">Please enter a valid year.</p>
              )}

              {!isValidDate && (
                <p className="error-message">
                  Microchip Date cannot be later than today's date.
                </p>
              )}
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                9. Name of Pet
              </label>
              <input
                type="text"
                className="form-control"
                id="nameofPet"
                placeholder=""
                maxLength={255}
                value={nameofPet}
                onChange={(event) => setNameofPet(event.target.value)}
                disabled
              />
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                10. Date of Birth <span className="star">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                id="dateofBirthPet"
                value={dateofBirthPet}
                onChange={handlePetbirthDateChange}
                onBlur={handlePetbirthDateChange}
                max={maxdate}
                min={minDate}
                disabled
              />
              {isValidDateofBirth && (
                <div className="invalid-feedback">
                  Please provide a Date of Birth.
                </div>
              )}

              {!isMinValidDateofBirth && (
                <p className="error-message">Please enter a valid year.</p>
              )}

              {!isValidDateofBirth && (
                <p className="error-message">
                  Date of Birth cannot be later than today's date.
                </p>
              )}
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                11. Sex <span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="sex"
                value={sex}
                onChange={(e) => setSex(e.target.value)}
                required
                disabled
              >
                <option value=""></option>
                <option value="1">Male</option>
                <option value="2">Female</option>
              </select>
              <div className="invalid-feedback">Please provide a Sex.</div>
            </div>

            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                12. Colour<span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="colour"
                value={colour}
                onChange={(e) => setColour(e.target.value)}
                required
                disabled
              >
                {colourOptions.map((colour) => (
                  <option key={colour.petColorID} value={colour.petColorID}>
                    {colour.colorName}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                13. Sterilised <span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="sterilised"
                value={sterilised}
                onChange={(e) => setSterilised(e.target.value)}
                required
                disabled
              >
                <option value=""></option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
              <div className="invalid-feedback">
                Please provide a Sterilised.
              </div>
            </div>

            <div className="mb-2 ">
              {ownerType !== 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  14. Pet Address
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  21. Pet Address
                </label>
              )}

              <div className="mb-2">
                {ownerType !== 3 && (
                  <label
                    htmlFor="exampleFormControlInput1"
                    className={`form-label mb-2 ${
                      !isSelectPetTypeSelected() ? "required" : ""
                    }`}
                  >
                    Please Select <span className="star">*</span>{" "}
                  </label>
                )}
                {ownerType === 3 && (
                  <label
                    htmlFor="exampleFormControlInput1"
                    className={`form-label mb-2 ${
                      !isSelectPetTypeSelected() ? "required" : ""
                    }`}
                  >
                    Please Select <span className="star">*</span>{" "}
                  </label>
                )}
                <div
                  className={`form-check ${
                    !isSelectPetTypeSelected() ? "is-invalid" : ""
                  }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="selectType"
                    value="1"
                    id="flexRadioDefault66"
                    checked={selectType === 1}
                    onChange={() => {
                      setSelectType(1);
                      setPostalCode(opostalCode);
                      setBlockNumber(oblockNumber);
                      setStreetName(ostreetName);
                      setUnitNumber(ounitNumber);
                      setFloorNumber(ofloorNumber);
                      setBuildingName(obuildingName);
                    }}
                    disabled
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault66"
                  >
                    Same as new owner
                  </label>
                </div>
                <div
                  className={`form-check ${
                    !isSelectPetTypeSelected() ? "is-invalid" : ""
                  }`}
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="selectType"
                    value="2"
                    id="flexRadioDefault77"
                    checked={selectType === 2}
                    onChange={() => {
                      setSelectType(2);
                      setPostalCode("");
                      setBlockNumber("");
                      setStreetName("");
                      setUnitNumber("");
                      setFloorNumber("");
                      setBuildingName("");
                    }}
                    disabled
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexRadioDefault77"
                  >
                    Other address
                  </label>
                </div>
                {submitted && !isSelectPetTypeSelected() && (
                  <div className="invalid-feedback">Please select a Type.</div>
                )}
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Postal Code
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="postalCode"
                      placeholder=""
                      maxLength={8}
                      pattern="[0-9]+"
                      value={postalCode}
                      onChange={postalCodeHandler}
                      readOnly={addressReadOnly}
                      disabled
                    />

                    {!postalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Block/House Number
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="blockNumber"
                      placeholder=""
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={blockNumber}
                      onChange={blockNoHandler}
                      readOnly={addressReadOnly}
                      disabled
                    />
                    {!blockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Floor Number
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="floorNumber"
                      placeholder=""
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={floorNumber}
                      onChange={floorNoHandler}
                      maxLength={3}
                      readOnly={addressReadOnly}
                      disabled
                    />
                    {!floorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Street Name
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="streetName"
                      placeholder=""
                      maxLength={64}
                      value={streetName}
                      onChange={(event) => setStreetName(event.target.value)}
                      readOnly={addressReadOnly}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Unit Number
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="unitNumber"
                      placeholder=""
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={unitNumber}
                      onChange={unitNoHandler}
                      maxLength={4}
                      readOnly={addressReadOnly}
                      disabled
                    />
                    {!unitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Building Name
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="buildingName"
                      placeholder=""
                      maxLength={64}
                      value={buildingName}
                      onChange={(event) => setBuildingName(event.target.value)}
                      readOnly={addressReadOnly}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-2 ">
              {ownerType !== 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  15. Remarks
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  24. Remarks
                </label>
              )}
              <textarea
                className="form-control"
                id="remarks"
                placeholder=""
                maxLength={200}
                value={remarks}
                onChange={(event) => setRemarks(event.target.value)}
                disabled
              />
              <p>{remarks ? remarks.length : 0}/200</p>

              <div className="invalid-feedback">Please provide a Remarks.</div>
            </div>
          </div>
          {displayOrigOwnerInfo && (
            <div>
              <h2 className="pt-2 pb-0">Owner Information</h2>
              <div className="inst-cnt mt-2">
                <div className="mb-2">
                  {ownerType !== 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      1. Owner ID Type <span className="star">*</span>{" "}
                    </label>
                  )}
                  {ownerType === 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      1. Owner ID Type <span className="star">*</span>{" "}
                    </label>
                  )}
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="ownerIdType"
                    value={ownerIdType}
                    onChange={handleOwnerIdTypeChange}
                    required
                    disabled
                  >
                    <option value=""></option>
                    <option value="2">NRIC</option>
                    <option value="1">FIN</option>
                    <option value="4">UEN</option>
                  </select>
                  <div className="invalid-feedback">
                    Please select Owner ID Type.
                  </div>
                </div>
                <div className="mb-2 ">
                  {ownerType !== 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      2. Owner ID <span className="star">*</span>
                    </label>
                  )}
                  {ownerType === 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      2. Owner ID <span className="star">*</span>
                    </label>
                  )}
                  <input
                    type="text"
                    className="form-control"
                    id="ownerId"
                    placeholder=""
                    maxLength={25}
                    value={ownerId}
                    onChange={(event) => setOwnerId(event.target.value)}
                    required
                    disabled
                  />
                  <div className="invalid-feedback">
                    Please provide a Owner ID.
                  </div>
                </div>

                <div className="mb-2 ">
                  {ownerType !== 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      3. Owner Name <span className="star">*</span>
                    </label>
                  )}
                  {ownerType === 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      3. Owner Name <span className="star">*</span>
                    </label>
                  )}
                  <input
                    type="text"
                    className="form-control"
                    id="ownerName"
                    placeholder=""
                    maxLength={355}
                    value={ownerName}
                    onChange={(event) => setOwnerName(event.target.value)}
                    required
                    disabled
                  />
                  <div className="invalid-feedback">
                    Please provide a Owner Name.
                  </div>
                </div>
                <div className="mb-2 ">
                  {ownerType !== 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      4. Owner Address
                    </label>
                  )}
                  {ownerType === 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      4. Owner Address
                    </label>
                  )}
                  <div className="row">
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Postal Code
                      </label>
                      <div className="mb-3 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          id="opostalCode"
                          placeholder=""
                          maxLength={8}
                          pattern="[0-9]+"
                          value={opostalCode}
                          onChange={opostalCodeHandler}
                          disabled
                        />

                        {!opostalCodeShowError && (
                          <div className="error-message">
                            Please enter numbers only. eg. "123456"
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Block/House Number
                      </label>
                      <div className="mb-3 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          id="oblockNumber"
                          placeholder=""
                          maxLength={4}
                          pattern="^[a-zA-Z0-9\s]+$"
                          value={oblockNumber}
                          onChange={oblockNoHandler}
                          disabled
                        />
                        {!oblockNoShowError && (
                          <div className="error-message">
                            Please enter charaters only. eg. "64FB"
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Floor Number
                      </label>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="ofloorNumber"
                          placeholder=""
                          pattern="^[a-zA-Z0-9\s]+$"
                          value={ofloorNumber}
                          onChange={ofloorNoHandler}
                          maxLength={3}
                          disabled
                        />
                        {!ofloorNoShowError && (
                          <div className="error-message  mb-3">
                            Please enter numbers eg. "123"
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Street Name
                      </label>
                      <div className="mb-3 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          id="ostreetName"
                          placeholder=""
                          maxLength={64}
                          value={ostreetName}
                          onChange={(event) =>
                            setoStreetName(event.target.value)
                          }
                          disabled
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Unit Number
                      </label>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="ounitNumber"
                          placeholder=""
                          pattern="^[a-zA-Z0-9\s]+$"
                          value={ounitNumber}
                          onChange={ounitNoHandler}
                          maxLength={4}
                          disabled
                        />
                        {!ounitNoShowError && (
                          <div className="error-message  mb-3">
                            Please enter numbers eg. "1234"
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label
                        htmlFor="exampleFormControlInput1"
                        className="form-label mb-1 small-label"
                      >
                        Building Name
                      </label>
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="obuildingName"
                          placeholder=""
                          maxLength={64}
                          value={obuildingName}
                          onChange={(event) =>
                            setoBuildingName(event.target.value)
                          }
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-2">
                  {ownerType !== 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      5. Owner Contact No <span className="star">*</span>
                    </label>
                  )}
                  {ownerType === 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      5. Owner Contact No <span className="star">*</span>
                    </label>
                  )}

                  <div className="row">
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        id="mobilecode"
                        value={mobilecode}
                        onChange={(e) => setMobileCode(e.target.value)}
                        required
                        disabled
                      >
                        {countryMobileCodes.map((code: any) => (
                          <option key={code} value={code}>
                            {code}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-10">
                      <input
                        type="text"
                        aria-describedby="emailHelp"
                        className={`form-control ${
                          !validMobileNo ? "is-invalid" : ""
                        }`}
                        id="mobileNo"
                        placeholder=""
                        pattern="[0-9]+"
                        value={mobileNo}
                        onChange={mobileNoHandler}
                        maxLength={mobilecode === "+65" ? 8 : 66}
                        required
                        disabled
                      />
                      <div className="invalid-feedback">
                        Please provide a contact Number.
                      </div>
                      {!validMobileNo && (
                        <div className="invalid-feedback">
                          Invalid mobile no. eg. +6591234567
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-2">
                  {ownerType !== 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      6. Owner Email<span className="star">*</span>
                    </label>
                  )}
                  {ownerType === 3 && (
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label mb-2"
                    >
                      6. Owner Email<span className="star">*</span>
                    </label>
                  )}
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder=""
                    maxLength={255}
                    value={email}
                    onChange={handleEmailChange}
                    required
                    disabled
                  />
                  <div className="invalid-feedback">
                    Please provide a Email.
                  </div>
                  {!validEmail && (
                    <p className="error-message">
                      Invalid email format. eg. abc@de.lk
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
          <h2 className="pt-2 pb-0">New Owner Information</h2>
          <div className="inst-cnt mt-2">
            <div className="mb-2">
              {ownerType !== 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  1. New Owner ID Type{" "}
                  {/* <span className="star">*</span>{" "} */}
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  1. New Owner ID Type <span className="star">*</span>{" "}
                </label>
              )}
              <select
                className="form-select"
                aria-label="Default select example"
                id="newownerIdType"
                value={newownerIdType}
                onChange={handlenewOwnerIdTypeChange}
                disabled
              >
                <option value=""></option>
                <option value="2">NRIC</option>
                <option value="1">FIN</option>
                <option value="4">UEN</option>
              </select>
              <div className="invalid-feedback">
                Please select New Owner ID Type.
              </div>
            </div>
            <div className="mb-2 ">
              {(ownerType !== 3 || ownerType === null) && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  2. New Owner ID
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  2. New Owner ID <span className="star">*</span>
                </label>
              )}
              <input
                type="text"
                className="form-control"
                id="newownerId"
                placeholder=""
                maxLength={25}
                value={newownerId}
                onChange={(event) => setnewOwnerId(event.target.value)}
                disabled
              />
              {/* <div className="invalid-feedback">
                Please provide a New Owner ID.
              </div> */}
            </div>

            <div className="mb-2 ">
              {ownerType !== 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  3. New Owner Name <span className="star">*</span>
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  3. New Owner Name <span className="star">*</span>
                </label>
              )}
              <input
                type="text"
                className="form-control"
                id="newownerName"
                placeholder=""
                maxLength={355}
                value={newownerName}
                onChange={(event) => setnewOwnerName(event.target.value)}
                required
                disabled
              />
              <div className="invalid-feedback">
                Please provide a New Owner Name.
              </div>
            </div>
            <div className="mb-2 ">
              {ownerType !== 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  4. New Owner Address
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  4. New Owner Address
                </label>
              )}
              <div className="row">
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Postal Code
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="newopostalCode"
                      placeholder=""
                      maxLength={8}
                      pattern="[0-9]+"
                      value={newopostalCode}
                      onChange={opostalCodenewHandler}
                      disabled
                    />

                    {!newopostalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Block/House Number
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="newoblockNumber"
                      placeholder=""
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={newoblockNumber}
                      onChange={oblockNonewHandler}
                      disabled
                    />
                    {!newoblockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Floor Number
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="newofloorNumber"
                      placeholder=""
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={newofloorNumber}
                      onChange={ofloorNonewHandler}
                      maxLength={3}
                      disabled
                    />
                    {!newofloorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Street Name
                  </label>
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="newostreetName"
                      placeholder=""
                      maxLength={64}
                      value={newostreetName}
                      onChange={(event) =>
                        setnewoStreetName(event.target.value)
                      }
                      disabled
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Unit Number
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="newounitNumber"
                      placeholder=""
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={newounitNumber}
                      onChange={ounitNonewHandler}
                      maxLength={4}
                      disabled
                    />
                    {!newounitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-1 small-label"
                  >
                    Building Name
                  </label>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="newobuildingName"
                      placeholder=""
                      maxLength={64}
                      value={newobuildingName}
                      onChange={(event) =>
                        setnewoBuildingName(event.target.value)
                      }
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              {ownerType !== 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  5. New Owner Contact No <span className="star">*</span>
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  5. New Owner Contact No <span className="star">*</span>
                </label>
              )}

              <div className="row">
                <div className="col-md-2">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="newmobilecode"
                    value={newmobilecode}
                    onChange={(e) => setnewMobileCode(e.target.value)}
                    required
                    disabled
                  >
                    {countryMobileCodes.map((code: any) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    aria-describedby="emailHelp"
                    className={`form-control ${
                      !newvalidMobileNo ? "is-invalid" : ""
                    }`}
                    id="newmobileNo"
                    placeholder=""
                    pattern="[0-9]+"
                    value={newmobileNo}
                    onChange={mobileNonewHandler}
                    maxLength={newmobilecode === "+65" ? 8 : 66}
                    required
                    disabled
                  />
                  <div className="invalid-feedback">
                    Please provide a contact Number.
                  </div>
                  {!newvalidMobileNo && (
                    <div className="invalid-feedback">
                      Invalid mobile no. eg. +6591234567
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              {ownerType !== 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  6. New Owner Email<span className="star">*</span>
                </label>
              )}
              {ownerType === 3 && (
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  6. New Owner Email<span className="star">*</span>
                </label>
              )}
              <input
                type="email"
                className="form-control"
                id="newemail"
                placeholder=""
                maxLength={255}
                value={newemail}
                onChange={handlenewEmailChange}
                required
                disabled
              />
              <div className="invalid-feedback">Please provide a Email.</div>
              {!newvalidEmail && (
                <p className="error-message">
                  Invalid email format. eg. abc@de.lk
                </p>
              )}
            </div>
          </div>

          {/* </div> */}
          {status === "3" && applicationType === "Owner Transfer" && (
            <div>
              <h2>Declaration</h2>
              <div className="inst-cnt mb-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={checkboxChecked}
                    onChange={handleCheckboxChange}
                    id="flexCheckDefault"
                    required
                    disabled
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    All the information given is correct and true to the best of
                    my knowledge.
                  </label>
                  {submitted &&
                    !checkboxChecked &&
                    status !== "3" &&
                    applicationType === "Owner Transfer" && (
                      <p className="error-message">
                        Please confirm the declaration checkbox
                      </p>
                    )}
                </div>
              </div>
              {displayAccept && (
                <div className="mb-3">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={site_Key}
                    onChange={() => setIsCaptchaValid(true)}
                    onExpired={() => setIsCaptchaValid(false)}
                  />
                  {submitted && !isCaptchaValid && (
                    <div className="error-message">
                      Please complete the reCAPTCHA verification.
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          <div className="mb-3">
            {displayAccept && (
              <div className="mb-2">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label mb-2"
                >
                  Transfer Code.<span className="star">*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  id="transferCode"
                  placeholder=""
                  maxLength={255}
                  value={transferCode}
                  onChange={(e) => setTransferCode(e.target.value)}
                  required
                />
                {transferCodeError && (
                  <p className="error-message">Please enter transfer code.</p>
                )}
                {/* {validatetransferCodeError && (
                  <p className="error-message">
                    Entered transfer code is incorrect.
                  </p>
                )} */}
              </div>
            )}
          </div>
          {displayAccept && (
            <div className="form-buttons">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleAccept}
                ref={errorRef}
              >
                Accept
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDecline}
              >
                Decline
              </button>
            </div>
          )}
          {displayCancel && (
            <>
              <button
                type="button"
                className="btn btn-warning"
                onClick={handleCancel}
              >
                Cancel Transfer
              </button>
            </>
          )}
          {isSubmiting && <Loader />}
          {errorMessage && <p className="error-message">{errorMessage}</p>}
        </div>
      </form>
    </>
  );
};

export default PetsTransferOwnerEditForm;
